export default function () {
  document.querySelectorAll(".popover-toggle").forEach((button) => {
    positionSubMenuPopovers(button as HTMLButtonElement);
  });

  function positionSubMenuPopovers(button: HTMLButtonElement) {
    let left: number | undefined;
    if (button) {
      left = button.getBoundingClientRect().x;
    }
    let popOverTarget = button.getAttribute("popovertarget");
    // console.log("target:", popOverTarget);
    // set popover target position to lower left of button
    const popover = document.querySelector(
      `ul#${popOverTarget}`
    ) as HTMLElement;
    console.log("Popover element:", popover);
    if (popover && left) {
      popover.style.left = `${left}px`;
    }
  }

	// resize observer to reposition popovers on window resize
	const resizeObserver = new ResizeObserver(() => {
		document.querySelectorAll(".popover-toggle").forEach((button) => {
			positionSubMenuPopovers(button as HTMLButtonElement);
		});
	});
	resizeObserver.observe(document.body);
}
